import ActionsModel from "../Actions/ActionsModel";
import RewardsModel from "../Rewards/RewardsModel";

export default class LoyaltyConfigModel {
    public enabled: boolean = false;
    public clientId: string = null;
    public conditions: {list: string[]} = { list: null };
    public actions: ActionsModel = new ActionsModel();
    public rewards: RewardsModel = new RewardsModel();
}